import { Link } from 'react-router-dom';

const stats = [
  { value: '3,600+', label: '影视条目' },
  { value: '12 类', label: '细分题材' },
  { value: '每日', label: '内容更新' },
  { value: 'HD', label: '画质演示' },
];

const badgeList = [
  '最新院线',
  '高分剧集',
  '热播综艺',
  '悬疑推理',
  '都市情感',
  '古装权谋',
  '国漫动画',
  '海外剧集',
];

export default function SiteIntro() {
  return (
    <section aria-label="网站简介" className="bg-primary-950 relative overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20dark%20navy%20blue%20backdrop%20with%20soft%20warm%20orange%20light%20streaks%20and%20film%20grain%20texture%2C%20flowing%20light%20ribbons%20in%20deep%20water%20tones%2C%20elegant%20premium%20streaming%20brand%20visual%2C%20minimal%20gradient%20composition%2C%20no%20text&width=1600&height=900&seq=v91-intro-abstract&orientation=landscape"
          alt="品牌视觉背景"
          title="91在线视频 品牌视觉"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/85 to-primary-950/50" />

      <div className="relative w-full px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-accent-500/15 text-accent-300 text-[11px] font-medium">
              <i className="ri-information-line" />
              关于 91在线视频
            </span>
            <h2 className="mt-4 text-2xl md:text-3xl font-bold text-background-50 leading-snug">
              一个把「找片」变简单的高清影视门户
            </h2>
            <p className="mt-4 max-w-2xl text-sm leading-7 text-background-200/80">
              91在线视频以现代门户与卡片探索结合的方式整理影视内容：从最新上线的电影、热播电视剧到每周更新的综艺节目，
              都可以通过分类筛选、地区与年份组合、以及关键词搜索快速定位。我们相信内容够全的同时，浏览本身也该是舒服的。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {badgeList.map((badge) => (
                <span
                  key={badge}
                  className="px-2.5 py-1 rounded-md bg-background-50/10 text-background-100/90 text-[11px] border border-background-50/10 whitespace-nowrap"
                >
                  {badge}
                </span>
              ))}
            </div>
            <div className="mt-8 flex flex-wrap items-center gap-3">
              <Link
                to="/category/movie"
                className="h-10 px-5 rounded-md bg-accent-500 hover:bg-accent-600 text-primary-950 text-sm font-semibold flex items-center gap-2 whitespace-nowrap transition-colors"
              >
                <i className="ri-compass-3-line" />
                开始探索
              </Link>
              <Link
                to="/about"
                className="h-10 px-5 rounded-md border border-background-50/25 text-background-50 text-sm flex items-center gap-2 whitespace-nowrap hover:bg-background-50/10 transition-colors"
              >
                <i className="ri-question-line" />
                了解站点
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5 grid grid-cols-2 gap-3 md:gap-4">
            {stats.map((item) => (
              <div
                key={item.label}
                className="rounded-lg bg-background-50/10 border border-background-50/10 px-4 py-5 backdrop-blur-sm"
              >
                <p className="text-xl md:text-2xl font-bold text-accent-300">{item.value}</p>
                <p className="mt-1 text-[11px] md:text-xs text-background-200/70">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}